export default __webpack_public_path__ + "static/media/zampanio_flowerkid_by_hex2.0a8461de.png";